/* Parquelectro <-> Lyst wishlist bridge.
   Product page: our "Favorito" button drives Lyst's injected button (kept hidden) and mirrors its state.
   Cards render native Lyst buttons (.lyst__wishlist-btn), so Lyst handles them directly. */
(function () {
  'use strict';
  function lystBtn() { return document.querySelector('.lyst__wishlist-detail-btn'); }
  function ourBtn() { return document.querySelector('button[aria-label="Favorito"]'); }

  function sync() {
    var l = lystBtn(), o = ourBtn();
    if (!l || !o) return;
    var on = l.classList.contains('active');
    o.classList.toggle('pe-wl-on', on);
    o.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function wire() {
    var l = lystBtn(), o = ourBtn();
    if (!l || !o || o.getAttribute('data-pe-lyst')) return !!(l && o);
    o.setAttribute('data-pe-lyst', '1');
    o.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var btn = lystBtn();
      if (btn) btn.click();
    }, true);
    new MutationObserver(sync).observe(l, { attributes: true, attributeFilter: ['class'] });
    sync();
    return true;
  }

  function start() {
    if (!document.querySelector('.product__info-container, product-info')) return;
    var tries = 0;
    var t = setInterval(function () { if (wire() || ++tries > 40) clearInterval(t); }, 250);
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
